import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

/**
 * ScrollingListChamonix component
 */
export default class ScrollingListChamonix extends Base {
  breakpoints = ['xxs', 'xs'];

  /**
   * Component Configuration
   */
  static config = {
    name: 'ScrollingListChamonix',
    refs: ['list', 'items[]'],
    options: {
      name: {
        type: String,
        default: '',
      },
    },
  };

  /**
   *
   */
  mounted() {
    let end = '';
    if (this.isMobile) {
      end = '+=1000px';
    } else {
      end = '+=1800px';
    }

    this.tl = gsap.timeline({
      scrollTrigger: {
        trigger: `#${this.$options.name}`,
        scrub: true,
        end,
      },
    });

    const offset = this.isMobile ? 0 : 16;
    const itemHeight = this.$refs.items[0].offsetHeight + offset;
    const itemWidth = this.$refs.items[0].offsetWidth;

    this.$refs.items.forEach((item, index) => {
      const nextYPosition = index * itemHeight * -1;
      const nextXPosition = index * itemWidth * -1;

      this.tl.to(this.$refs.items, {
        opacity: 1,
        duration: 0.4,
      });

      this.tl
        .to(this.$refs.items, {
          y: this.isMobile ? 0 : nextYPosition,
          x: this.isMobile ? nextXPosition : 0,
          stagger: 0.04,
          duration: 0.4,
          ease: 'back.in',
          onReverseComplete: () => {
            this.switchItemStates(index - 1);
          },
          onComplete: () => {
            this.switchItemStates(index);
          },
        })
        .addLabel(`item-${index}`);
    });
  }

  /**
   * Check if device is mobile
   * @returns {boolean}
   */
  get isMobile() {
    return this.breakpoints.includes(this.$services.get('resized').breakpoint);
  }

  /**
   * Switch item and image states
   * @param {number} index current index
   * @returns {void}
   */
  switchItemStates(index) {
    if (index < 0) {
      return;
    }

    this.$refs.items.forEach((item, i) => {
      if (i !== index) {
        item.classList.remove('text-red-chamonix');
        item.classList.add('text-white/30');
      }
    });

    if (this.$refs.items[index]) {
      this.$refs.items[index].classList.add('text-red-chamonix');
      this.$refs.items[index].classList.remove('text-white/30');
    }
  }
}
